export const PUBLIC_PAGE_PREFERRED_LANGUAGE_SELECTED = "localization/public-page-preferred-language-selected"
export const BROWSER_LANGUAGE_CHANGED = "localization/browser-language-changed"

export function publicPagePreferredLanguageSelected(language) {
  return { type: PUBLIC_PAGE_PREFERRED_LANGUAGE_SELECTED, payload: language }
}
export function browserLanguageChanged(language) {
  return { type: BROWSER_LANGUAGE_CHANGED, payload: language}
}